<template>


<div class="fixed-top" id="header-fixed">


  <b-navbar toggleable="lg" variant="" type=""  >
    <b-navbar-brand href="#">
      <router-link to="/Assamese">
      <table>
        <tbody>
          <tr>
              <td rowspan="5">  <b-img class="logo" src="../assets/apdcl_logo.png" fluid   alt="logo"></b-img></td>
          </tr>
            <tr>
              <td id="title-a" class="title-a text-blue ">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড</td>
            </tr>

            <tr>
              <td id="title-e" class="title-e text-blue">ASSAM POWER DISTRIBUTION COMPANY LIMITED</td>
            </tr>

        </tbody>
      </table>
    </router-link>
  </b-navbar-brand>

  <b-navbar-toggle target="nav-collapse" style="border:none; outline: none;">
      <template>
        <div style="border:solid 1px black;border-radius:3px;font-size: 2rem;">
        <b-icon icon="list"  ></b-icon>
      </div>
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav class="nav-bgcolor responsiveNavbar" style="">


      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
          <b-nav-item href="#"><router-link toggle-class="r-link" to="/Assamese">মূখ্যপৃষ্ঠা</router-link></b-nav-item>
          <b-nav-item href="#"><router-link toggle-class="r-link" to="/AS_ActsAndRules">আইন আৰু নীতি</router-link></b-nav-item>
          <!-- <b-nav-item href="#"><router-link toggle-class="r-link" to="/Tender">Tender</router-link></b-nav-item> -->

          <b-nav-item-dropdown toggle-class="r-link" text="নিবিদা" right>
           <b-dropdown-item href="AS_TenderCurrent"><span class="dropdownItem" >চলিত বিত্তীয় বৰ্ষ</span></b-dropdown-item>
           <b-dropdown-item href="AS_TenderPrevious"><span class="dropdownItem" >বিগত বিত্তীয় বৰ্ষ</span></b-dropdown-item>
           <b-dropdown-item href="AS_TenderArchive"><span class="dropdownItem" >আৰ্কাইভ</span></b-dropdown-item>
           <!-- <b-dropdown-item href="#"><router-link to="/TenderArchive">Financial Year 2018-2019</router-link></b-dropdown-item> -->
         </b-nav-item-dropdown>

         <!-- <b-nav-item-dropdown toggle-class="r-link" text="Newsroom" right>
           <b-dropdown-item href="#"><router-link to="/Newsletter">Newsletter</router-link></b-dropdown-item>
           <b-dropdown-item href="#"><router-link to="/BijuleeNewsBulletin">Bijulee News Bulletin</router-link></b-dropdown-item>
             <b-dropdown-item href="#"><router-link to="/PressRelease">Press Release</router-link></b-dropdown-item>
           <b-dropdown-item><a href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank">Talk Show about APDCL</a></b-dropdown-item>
           <b-dropdown-item href="#"><router-link to="/Testimonial">Testimonials</router-link></b-dropdown-item>
         </b-nav-item-dropdown> -->

         <b-nav-item-dropdown toggle-class="r-link" text="বাতৰি " right>
           <b-dropdown-item href="AS_Award"><span class="dropdownItem " >সন্মান আৰু স্বীকৃতি</span></b-dropdown-item>
           <b-dropdown-item href="AS_Newsletter"><span class="dropdownItem" >বাৰ্তালোচনী</span></b-dropdown-item>
           <b-dropdown-item href="AS_BijuleeNewsBulletin"><span class="dropdownItem" >বিজুলী প্ৰচাৰ-পত্ৰিকা</span></b-dropdown-item>
           <b-dropdown-item href="AS_PressRelease"><span class="dropdownItem" >প্ৰেছ বিজ্ঞপ্তি</span></b-dropdown-item>
           <b-dropdown-item href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank"><span class="dropdownItem" >
               টক্-শ্ব’ত এপিদিচিএল</span></b-dropdown-item>
           <b-dropdown-item href="AS_Testimonial"><span class="dropdownItem" >দস্তাবেজ</span></b-dropdown-item>
           <b-dropdown-item href="AS_Workshop"><span class="dropdownItem" >কৰ্মশালা আৰু আলোচনা চক্ৰ</span></b-dropdown-item>

         </b-nav-item-dropdown>


          <b-nav-item href="#"><router-link toggle-class="r-link" to="/AS_Contact">যোগাযোগ কৰক</router-link></b-nav-item>

          <b-nav-item><div id="login"><b-button v-b-modal.modal-headerFixed size="sm" variant="outline-danger" style="margin-top: -5px;">
            লগ্‌-ইন </b-button></div>
          </b-nav-item>



          <b-modal
          no-close-on-esc
          no-close-on-backdrop
           class="modal fade" id="modal-headerFixed"  hide-footer title="আপোনাৰ একাউণ্টত লগ ইন কৰক">
            <div>
              <b-overlay
                :show="show"
                spinner-variant="primary"
                spinner-large
                rounded="sm"
                style="z-index:10000;position:absolute"
                variant="dark"
                id="loader"
              >


                <b-row>
                  <b-col cols=4>
                     <span style="color: #0d47a1;">লগইন কৰক :</span>
                  </b-col>
                    <b-col cols=3>
                      <b-form-radio v-model="selected" name="userRadio" id="consumerRadio" value="consumer">উপভোক্তা</b-form-radio>
                    </b-col>
                  <!-- <b-col cols=3>
                    <b-form-radio v-model="selected" name="userRadio" id="adminRadio" value="admin">প্ৰশাসক</b-form-radio>
                  </b-col> -->
                  <p id="selectRadio" hidden>Selected: {{ selected }}</p >
                </b-row>


            <br>
              <!-- USER LOGIN-->
                <div id="userDiv" class="showDiv" >
                      <label>ম'বাইল নম্বৰ প্ৰবিষ্ট কৰক  </label>
                    <b-input-group class="mb-2" style="width:100%;padding-bottom:10px;">
                      <b-input-group-prepend is-text>
                        <b-icon icon="phone"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input type="number" id="mobileNoFx" @change="" autocomplete="off" placeholder="ম'বাইল নম্বৰ"></b-form-input>
                    </b-input-group>

                    <div id="sendOtpBtn" class="showDiv">
                      <b-row>
                        <b-col cols="12" offset="">

                            <router-link to="">
                              <b-button block  id="" @click="sendOtp()" variant="primary">অ'টিপি প্ৰেৰণ কৰক</b-button>
                              </router-link>

                        </b-col>
                      </b-row>
                    </div>

                    <div  id="otpDiv" class="hideDiv">

                      <label>অ'টিপি প্ৰবিষ্ট কৰক</label>
                    <b-input-group class="mb-2" style="width:100%;">

                      <b-input-group-prepend is-text>
                        <b-icon icon="check2-circle"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input type="text" id="otp" autocomplete="off" placeholder="অ'টিপি প্ৰবিষ্ট কৰক"></b-form-input>
                    </b-input-group>
                    <span style="color:red;padding-left:40%" id="otpInvalid"> </span>
                    <b-row>
                      <b-col cols="12" offset="">
                            <b-button block  @click="loginUser()" variant="primary">লগ ইন</b-button>
                            <b-button block  @click="resendOtp()" variant="outline-primary">অ'টিপি পুনৰ প্ৰেৰণ কৰক</b-button>
                      </b-col>
                    </b-row>
                  </div>

                  </div>

                    <!-- ADMIN LOGIN-->
                    <div id="adminDiv" style="display:none">
                    <b-input-group class="mb-2" style="width:100%;">
                      <b-input-group-prepend is-text>
                        <b-icon icon="person-fill"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input type="number" :state="userIdState" v-model="user_id" id="user_id" @change="validateConsumer_false('user_id')" autocomplete="off" placeholder="User ID"></b-form-input>
                    </b-input-group>
                    <br><br>
                    <b-input-group class="mb-2" style="width:100%;">
                      <b-input-group-prepend is-text>
                        <b-icon icon="lock-fill"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input type="password" id="password" autocomplete="off" placeholder="Password"></b-form-input>
                    </b-input-group>
                    <br><br>
                    <b-row>
                      <b-col cols="12" offset="">

                          <router-link to="">
                            <b-button block  id="logInBtn" @click="login()" variant="primary">Log In</b-button>
                            </router-link>

                      </b-col>
                    </b-row>
                  </div>


                    <b-row>
                      <b-col cols="12" style="text-align:center">
                          <span >আপোনাৰ একাউণ্ট নাই নেকি?  <br>
                          <router-link to="/AS_ConsumerRegistration">পঞ্জীয়ন কৰক</router-link>
                        </span>
                      </b-col>
                    </b-row>
                    <br><br>

              </b-overlay>
            </div>
          </b-modal>

      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
  <span class="language" id="language" >
      <router-link class="r-link customSpan" to="/">English</router-link>
    </span>

</div>

</template>


<script scoped="true">

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

//var urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
Vue.use(Vuex)

var user = 0;

export default{
  computed:{
   userIdState() {
      return this.user_id.length == 12 ? true : false
      //this.login()
    }
  },
  data() {
      return {
        selected: 'consumer',
        user_id: '',
        show: false,
      }
    },

  methods:{

    validateConsumer(x)
    {

      var user = document.getElementById(x);

      if(isNaN(user.value)){
        this.$bvToast.toast('Enter Numbers Only!', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        user.value="";
        user.focus();
      }
    },
    sendOtp()
    {

      var mb = document.getElementById("mobileNoFx");
      var mobile = mb.value;

      if(mobile == ""){
        this.$bvToast.toast('Mobile can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      else if((mobile.length != 10)){
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      var parent=this;
      this.show=true;


      axios.post(this.$urlCommon+"/myBijulee/fetchConsumer?mobile_no="+mobile).then(function(response) {
        parent.show=false;
      if(response.data.message=="success")
      {
        axios.post(parent.$urlCommon+"/api/generateOtp?mobNo="+mobile).then(function(response) {
          console.log(response.data);

          if (response.data.message == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            document.getElementById("mobileNoFx").disabled=true;
            document.getElementById("otpDiv").classList.add("showDiv");
            document.getElementById("sendOtpBtn").classList.remove("showDiv");
            document.getElementById("sendOtpBtn").classList.add("hideDiv");
          }
        });
      }
      else {
        {
          parent.$bvToast.toast('Mobile Number not registered ! Kindly Register First ', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        }
      }
    });


    },
    resendOtp()
    {
      var parent =this;
      var mobile = document.getElementById("mobileNoFx").value;
      parent.show= true;
      axios.post(this.$urlCommon+"/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
        parent.show= false;
        if (response.data.message == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },
    loginUser()
    {
      var parent=this;
      this.show=true;
      var mobile = document.getElementById("mobileNoFx").value;
      var otp = document.getElementById("otp").value;

      console.log(mobile+"#######"+otp)
      axios.post(this.$urlCommon+"/api/validateOtp?mobNo="+mobile+"&otpNo="+otp).then(function(response) {
        console.log(response.data);

        if (response.data.message == "VALID") {
          parent.show=false;
          parent.$bvToast.toast('OTP Successfully Verified !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });

          parent.$router.push({ path: '/ConsumerDashboard?mobileNo=' + mobile })
          return;
        }
        else {
          parent.show= false;
          document.getElementById("otpInvalid").innerHTML="Invalid OTP";
        }
      });

    },
    login(){
      var user_id = document.getElementById("user_id");
      var pw = document.getElementById("password");
      var user = user_id.value;

      if(user == ""){
        this.$bvToast.toast('User Id can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
      }
      else if((user.length != 12)&&(user.length != 8)){
        this.$bvToast.toast('Enter a Valid User ID !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
      }
      else if(pw.value == ""){
        this.$bvToast.toast('Password can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
      }
      else{
      var dataToSend = {
        "user_id": user_id.value,
        "password": pw.value
      }
    //  console.log(dataToSend);
      }


        var rad = document.querySelector('input[name="userRadio"]:checked').value;
        var PARENT = this
        if(rad == "consumer"){
          axios.post(this.$urlCommon + "/api/web/login/consumer", dataToSend).then(function(response) {
            if (response.data == "success") {
              PARENT.$router.push({ path: '/ConsumerDashboard?consNo=' + user_id.value })
              return;
            }
          });
        } else {
          axios.post(this.$urlCommon + "/api/web/login/admin", dataToSend).then(function(response) {
            if (response.data == "success") {
              PARENT.$router.push({ path: '/CreateContact' })
              return;
            }
          });
        }
    }

  },
  mounted(){

  }
}

</script>

<style lang="scss" scoped="true" >
#header-fixed
{
  transition: 0.6s;
  background-color: #ffff;
  box-shadow: 0 4px 7px 1px #e0e0e0;
}

.title-a
{
  font-size: 1.3rem;
  font-weight: 900;
  margin-top: 0px;
  letter-spacing: 0.5px;

}
.title-e
{
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.5px;

}

table
{
  color:#e4dbdb;
}
td
{
  text-align: left !important;
}
.text-orange
{
  color: #ff5722
}
.text-blue
{
  color: #01579b;
}
.border
{
  border:1px solid;
}
.support
{
  display:none;
}
.language
{
  float: right;
  margin-top: -95px ;
  margin-right: 25px;
  position:relative;
  z-index:1000;
}
.customSpan
{
  background-color: #fff78d;
padding: 4px 10px 4px 10px;
font-weight: 500;
border-radius: 2px;
}

#header,#title-e,#title-a,#tagline-a,#tagline-e,#support,#language
{
  transition: 0.5s;
}

.form-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 3px solid #f1f1f1;
  z-index: 9;
}
.logo{
    height:75px;
    width:75px;
    margin-right:20px;
}


.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
</style>
